export default {
    title: 'MoonGroup помічник',
    welcome: {
        greeting: 'Привіт! Я можу відповісти на запитання про MoonGroup — наші послуги, продукти та підхід до роботи.',
        hint: 'Спробуйте одне з цих або запитайте будь-що:',
    },
    examplePrompts: [
        'Які послуги ви пропонуєте?',
        'Розкажіть про ваші продукти',
        'Скільки триває типовий проєкт?',
        'Як з вами зв\'язатися?',
    ],
    composer: {
        placeholder: 'Запитайте будь-що…',
        send: 'Надіслати',
        hint: 'Enter — надіслати, Shift+Enter — новий рядок',
        charCount: '{used}/{max}',
    },
    states: {
        thinking: 'Думаю…',
        offline: 'Я зараз офлайн — спробуйте за хвилину.',
        rateLimited: 'Трохи швидко — дайте хвилинку і спробуйте знову.',
        error: 'Щось пішло не так. Спробувати ще раз?',
        paused: 'Чат призупинено на деякий час — спробуйте пізніше.',
        inputRejected: 'Не вдалося надіслати це повідомлення. Перефразуйте та спробуйте ще раз.',
        scrollToBottom: 'Нове повідомлення',
    },
    toast: {
        replyReady: 'Помічник відповів',
        leadSent: 'Надіслано команді — ми зв\'яжемося з вами',
    },
    actions: {
        expand: 'Розгорнути',
        collapse: 'Згорнути',
        close: 'Закрити',
        retry: 'Спробувати знову',
        openChat: 'Відкрити чат',
        askAi: 'Запитати AI',
    },
};
